<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['getFundAttributes']),
		isTargetDate() {
			return (
				this.getFundAttributes &&
					this.getFundAttributes.Objective &&
					this.getFundAttributes.Objective.toLowerCase().includes('targetdate')
			);
		},
		// Get dynamic statistics for the anchor by objective
		$getDynamicStatisticsForAnchorByObjective() {
			return {
				portMgrName: this.isTargetDate ? ['TDSC_N'] : ['portMgrName'],
				portfolioManagementName: this.isTargetDate ? ['TDSC_N'] : ['portfolioManagementName'],
				underlyingFunds_cashEquivalents: this.isTargetDate ? ['fundAllocationTD'] : ['UNDFUND_VIM']
			};
		}
	}
};
</script>
